function bufferToBase64URLString(buffer: any) {
  const bytes: any = new Uint8Array(buffer);
  let str = "";

  for (const charCode of bytes) {
    str += String.fromCharCode(charCode);
  }

  const base64String = btoa(str);

  return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
const attachments = ["cross-platform", "platform"];

function toAuthenticatorAttachment(attachment: any) {
  if (!attachment) {
    return;
  }

  if (attachments.indexOf(attachment) < 0) {
    return;
  }

  return attachment;
}

function base64URLStringToBuffer(base64URLString: any) {
  // Convert from Base64URL to Base64
  const base64 = base64URLString.replace(/-/g, "+").replace(/_/g, "/");
  /**
   * Pad with '=' until it's a multiple of four
   * (4 - (85 % 4 = 1) = 3) % 4 = 3 padding
   * (4 - (86 % 4 = 2) = 2) % 4 = 2 padding
   * (4 - (87 % 4 = 3) = 1) % 4 = 1 padding
   * (4 - (88 % 4 = 0) = 4) % 4 = 0 padding
   */
  const padLength = (4 - (base64.length % 4)) % 4;
  const padded = base64.padEnd(base64.length + padLength, "=");

  // Convert to a binary string
  const binary = atob(padded);

  // Convert binary string to buffer
  const buffer = new ArrayBuffer(binary.length);
  const bytes = new Uint8Array(buffer);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return buffer;
}

function utf8StringToBuffer(value: any) {
  return new TextEncoder().encode(value);
}

export const useWebAuthn = () => {
  const create = async (options: any) => {
    try {
      if (!options) {
        return;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { excludeCredentials: _, ...rest } = options;

      const opt = {
        ...rest,
        challenge: base64URLStringToBuffer(rest.challenge),
        user: {
          ...rest.user,
          id: utf8StringToBuffer(rest.user.id),
        },
      };

      const credential: any = await navigator.credentials.create({
        publicKey: {
          ...opt,
        },
      } as any);

      const { id, rawId, response, type } = credential as any;
      let transports = undefined;
      if (typeof response.getTransports === "function") {
        transports = response.getTransports();
      }
      const result = {
        id,
        rawId: bufferToBase64URLString(rawId),
        response: {
          attestationObject: bufferToBase64URLString(
            response.attestationObject
          ),
          clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
          transports,
        },
        type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: toAuthenticatorAttachment(
          credential.authenticatorAttachment
        ),
      };

      return result;
    } catch (error) {
      return { isError: true, error };
    }
  };

  const get = async (options: any) => {
    try {
      const loginOpts = {
        challenge: base64URLStringToBuffer(options.challenge),
        allowCredentials: options.allowCredentials.map((devices: any) => ({
          ...devices,
          id: base64URLStringToBuffer(devices.id),
        })),
        timeout: "60000",
      };

      const credential: any = await navigator.credentials.get({
        publicKey: {
          ...loginOpts,
        },
      } as any);

      const { id, rawId, response, type } = credential;

      const newCredential = {
        id,
        rawId: bufferToBase64URLString(rawId),
        response: {
          authenticatorData: bufferToBase64URLString(
            response.authenticatorData
          ),
          clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
          signature: bufferToBase64URLString(response.signature),
          userHandle: bufferToBase64URLString(response.userHandle),
        },
        type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: toAuthenticatorAttachment(
          credential.authenticatorAttachment
        ),
      };
      return newCredential;
    } catch (error) {
      return { isError: true, error };
    }
  };

  return {
    create,
    get,
  };
};
